import { render, staticRenderFns } from "./Conflict.vue?vue&type=template&id=76eba920"
import script from "./Conflict.vue?vue&type=script&lang=js"
export * from "./Conflict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports